import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import HeaderList from 'flarum/forum/components/HeaderList';
import HeaderListItem from 'flarum/forum/components/HeaderListItem';
import ItemList from 'flarum/common/utils/ItemList';
export default class FlagList extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    const state = this.attrs.state;
    return m(HeaderList, {
      className: "FlagList",
      title: app.translator.trans('flarum-flags.forum.flagged_posts.title'),
      controls: this.controlItems(),
      hasItems: state.hasItems(),
      loading: state.isLoading(),
      emptyText: app.translator.trans('flarum-flags.forum.flagged_posts.empty_text'),
      loadMore: () => state.hasNext() && !state.isLoadingNext() && state.loadNext()
    }, m("ul", {
      className: "HeaderListGroup-content"
    }, this.content(state)));
  }
  controlItems() {
    const items = new ItemList();
    return items;
  }
  content(state) {
    if (!state.isLoading() && state.hasItems()) {
      return state.getPages().map(page => {
        return page.items.map(flag => {
          const post = flag.post();
          return m("li", null, m(HeaderListItem, {
            className: "Flag",
            avatar: m(Avatar, {
              user: post.user() || null
            }),
            icon: "fas fa-flag",
            content: app.translator.trans('flarum-flags.forum.flagged_posts.item_text', {
              username: username(post.user()),
              em: m("em", null),
              discussion: post.discussion().title()
            }),
            excerpt: post.contentPlain(),
            datetime: flag.createdAt(),
            href: app.route.post(post),
            onclick: e => {
              e.redraw = false;
            }
          }));
        });
      });
    }
    return null;
  }
}
flarum.reg.add('flarum-flags', 'forum/components/FlagList', FlagList);